import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getAssociateCompanyService } from 'services/analyticsCenter/businessProfile';
import { AssociateCompanyParamsTypes, AssociateCompanyTypes } from 'services/analyticsCenter/businessProfile/types';

type AssociateCompany = {
  associateCompany: AssociateCompanyTypes[];
}

const initialState: AssociateCompany = {
  associateCompany: [],
};

export const getAssociateCompanyAction = createAsyncThunk(
  'associateCompany/getAssociateCompanyAction',
  async (params: AssociateCompanyParamsTypes, { rejectWithValue }) => {
    try {
      return await getAssociateCompanyService(params);
    } catch (error) {
      return rejectWithValue(error as ErrorResponse);
    }
  },
);

const associateCompanySlice = createSlice({
  name: 'associateCompany',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getAssociateCompanyAction.fulfilled, ($state, action) => {
      $state.associateCompany = action.payload;
    });
  },
});

export default associateCompanySlice.reducer;
